import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  left: {
    minWidth: 0,
    flexGrow: 1,
  },
  title: {
    fontWeight: 800,
    letterSpacing: '-0.02em',
    margin: 0,
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
    fontSize: '0.95rem',
  },
  breadcrumbs: {
    fontSize: '0.85rem',
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
}));

/**
 * En-tête de page standard avec breadcrumbs, titre, sous-titre et actions.
 *
 * @param {string} title
 * @param {string} [subtitle]
 * @param {Array<{label:string, to?:string}>} [breadcrumbs]
 * @param {React.ReactNode} [actions]
 */
const PageHeader = ({ title, subtitle, breadcrumbs, actions }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.left}>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            className={classes.breadcrumbs}
            aria-label="breadcrumb"
          >
            {breadcrumbs.map((b, i) =>
              b.to && i < breadcrumbs.length - 1 ? (
                <Link
                  key={i}
                  component={RouterLink}
                  to={b.to}
                  color="inherit"
                  underline="hover"
                >
                  {b.label}
                </Link>
              ) : (
                <Typography key={i} color="textPrimary" variant="caption">
                  {b.label}
                </Typography>
              )
            )}
          </Breadcrumbs>
        )}
        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" className={classes.subtitle}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box className={classes.actions}>{actions}</Box>}
    </Box>
  );
};

export default PageHeader;
